import { useMutation } from '@tanstack/react-query';
import { signInWithEmailAndPassword, User } from 'firebase/auth';
import UserCredentials from '@/features/auth/signup/types/userCredentials.ts';
import { auth } from '@/lib/firebase';
import { getFirebaseErrorMessage } from '@/utils/exceptions/firebaseErrors.ts';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';
import { FirebaseError } from 'firebase/app';

export default function useLogin(redirectUrl?: string) {
  const navigate = useNavigate();

  const login = async (userCredentials: UserCredentials): Promise<User> => {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      userCredentials.email,
      userCredentials.password,
    );
    return userCredential.user;
  };

  return useMutation({
    mutationFn: login,
    onSuccess: () => {
      toast.success('Zalogowano pomyślnie');
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        navigate({ to: '/app' });
      }
    },
    onError: (error) => {
      if (error instanceof FirebaseError) {
        const errorMessage = getFirebaseErrorMessage(error?.code);
        toast.error(errorMessage);
      } else {
        console.error(error);
      }
    },
  });
}
